import { render, staticRenderFns } from "./BtnAtualizarAcao.vue?vue&type=template&id=1a5c577b"
import script from "./BtnAtualizarAcao.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports